"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSchedule = resolveSchedule;
const time_js_1 = require("./time.js");
// Works because "HH:MM" strings are zero-padded and equal-length.
function timeLeq(a, b) {
    return a <= b;
}
/**
 * Resolve the active period (if any) for a school, given today's calendar
 * entry, the schedule type it points to, and that schedule type's periods.
 * Pure function — no DB access; callers own fetching the plain inputs.
 *
 * Mirrors the active-period resolution formerly inlined in
 * apps/passes-api/src/routes/passes.ts.
 */
function resolveSchedule(input) {
    const now = input.now ?? new Date();
    const date = (0, time_js_1.getTodayInTimezone)(input.timezone, now);
    if (!input.calendarEntry ||
        input.calendarEntry.scheduleTypeId === null ||
        !input.scheduleType) {
        return { date, periods: [], currentPeriod: null };
    }
    const currentTime = (0, time_js_1.getCurrentTimeInTimezone)(input.timezone, now);
    const { startBuffer, endBuffer } = input.scheduleType;
    const periods = input.periods.map((p) => ({
        ...p,
        // Clamped, not wrapped: a start buffer crossing midnight must yield
        // "00:00" (not wrap to "23:xx") and an end buffer crossing midnight must
        // yield "23:59" (not wrap to "00:xx") — a wrapped bound can never match.
        windowStart: (0, time_js_1.addMinutesToTimeClamped)(p.startTime, -startBuffer),
        windowEnd: (0, time_js_1.addMinutesToTimeClamped)(p.endTime, endBuffer),
    }));
    // Buffer windows of adjacent periods overlap — order so the earliest
    // start-time match wins deterministically, independent of input order.
    const byStartTime = [...periods].sort((a, b) => a.startTime < b.startTime ? -1 : a.startTime > b.startTime ? 1 : 0);
    const currentPeriod = byStartTime.find((p) => timeLeq(p.windowStart, currentTime) && timeLeq(currentTime, p.windowEnd)) ?? null;
    return { date, periods, currentPeriod };
}
